import React from "react";
import { Card } from "./ui/card";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const WelcomeScreen = ({
  userInput,
  setUserInput,
  handleSend,
  sampleQuestions,
}) => {
  return (
    <motion.div
      key="initialUI"
      initial={{ opacity: 0, scale: 1.05 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 1.05 }}
      transition={{ duration: 0.3 }}
      className="flex flex-col items-center w-full"
    >
      <div className="flex flex-col items-center w-full">
        <h1 
          className="text-gray-900 dark:text-white mt-8 mb-2 text-center"
          style={{
            fontSize: '3.75rem',
            lineHeight: '1.1',
            fontWeight: 'bold'
          }}
        >
          CoachAI
        </h1>
        
        <h2 
          className="text-gray-700 dark:text-gray-300 mb-8 text-center"
          style={{
            fontSize: '1rem',
            lineHeight: '1.5'
          }}
        >
          Your personal Conversational Coaching Assistant
        </h2>

        <Card className="w-full max-w-3xl p-4 bg-white/70 dark:bg-gray-800/80 shadow-lg rounded-2xl flex items-center mb-8 backdrop-blur-sm">
          <Input
            value={userInput}
            onChange={(e) => setUserInput(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleSend();
              }
            }}
            placeholder="Ask me about coaching conversations, workplace challenges, performance situations..."
            className="flex-1 bg-transparent text-gray-900 dark:text-white p-4 rounded-lg focus:outline-none text-base"
          />
          <Button
            onClick={() => handleSend()}
            className="ml-3 bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 rounded-full w-10 h-10 flex items-center justify-center"
          >
            <ArrowRight className="h-5 w-5 text-gray-700 dark:text-white" />
          </Button>
        </Card>

        <div className="mt-4 text-gray-700 dark:text-gray-300 text-base font-medium">
          Sample Questions You Can Ask
        </div>
        
        <div className="mt-4 flex flex-col items-center space-y-3 w-full max-w-3xl">
          {sampleQuestions.map((question, index) => (
            <button
              key={index}
              className="w-full bg-white/60 text-gray-900 py-3 px-6 rounded-full text-left transition hover:bg-white/75 dark:bg-gray-900/60 dark:text-white dark:hover:bg-gray-800/70 shadow-md border border-gray-100/30 dark:border-gray-800/40 backdrop-blur-sm"
              onClick={() => handleSend(question)}
            >
              {question}
            </button>
          ))}
        </div>
        
        {/* Removed duplicate disclaimer text */}
      </div>
    </motion.div>
  );
};

export default WelcomeScreen;
